import { GET_API, PUT_API, PATCH_API } from "../../Functionalities/APIs";

export const ManageProfile = async (e, data, keyword, params) => {
    let path = "/user/profile/";

    if (keyword == "get") {
        let result = GET_API("", params, path);
        // void 0

        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }

    if (keyword == "update") {
        var fdata = new FormData()
        if (data.keyword == "super") {
            fdata.append("username", data.username)
            fdata.append("new_username", data.new_username)
            if (data.password !== "")
                fdata.append("password", data.password)
            fdata.append("new_password", data.new_password)
            fdata.append("keyword", "update_superuser")
        }
        else if (data.keyword == "shop") {
            // No "keyword": the backend's profile_edit branch always writes to
            // request.user, so this has to fall through to the admin branch that
            // honours user_id. is_approved/is_blocked are echoed back unchanged
            // because the backend reads them unconditionally for a superuser.
            fdata.append("user_id", data.id)
            fdata.append("name", data.name)
            if (data.email != "") {
                fdata.append("email", data.email)
            }
            fdata.append("mobile", data.mobile)
            fdata.append("username", data.username)
            fdata.append("address1", data.address1)
            fdata.append("latitude", data.latitude)
            fdata.append("longitude", data.longitude)
            fdata.append("is_approved", data.is_approved)
            fdata.append("is_blocked", data.is_blocked)
            if (data.password !== "") {
                fdata.append("password", data.password)
            }
        }
        else {
            fdata.append("name", data.name)
            if (data.email != "") {
                fdata.append("email", data.email)
            }
            fdata.append("mobile", data.mobile)
            fdata.append("username", data.username)
            // if(data.address1)
            //     fdata.append("address1", data.address1)
            // if(data.latitude)
            //     fdata.append("latitude", data.latitude)
            // if(data.longitude)
            //     fdata.append("longitude", data.longitude)
            fdata.append("keyword", "profile_edit")
            // fdata.append("is_approved", true)
            // fdata.append("is_blocked", false)
        }

        // for (var pair of fdata.entries()) {
        //     void 0
        //   }

        let result = PUT_API(fdata, "", path, "");
        // void 0

        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
}

export const ManagePassword = async (e, data, keyword, params) => {
    let path = "/user/profile/";
    if (keyword == "patch") {
        var fdata = new FormData()
        // fdata.append("user_id", data.id)
        fdata.append("keyword", "change_password")
        fdata.append("password", data.password)
        fdata.append("new_password", data.new_password)
        fdata.append("username", data.username)

        let result = PATCH_API(fdata, "", path);
        // void 0

        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }

}
